import React from 'react';
import { Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

const ProductItem = ({ node, isBold, isProductParameterized }) => {
    return (
        <div className={'product-item'}>
            <Typography
                color={node.productEnabled ? 'inherit' : 'error'}
                className={`center-vertically ${isBold ? 'bold-text' : ''}`}
            >
                {isProductParameterized && <SettingsIcon className="ProductParameterizedIcon" />} {node.productName}
            </Typography>
        </div>
    );
};

export default ProductItem;